import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["expression", "result"]
  static values = {
    initial: String,
    max: Number,
    unit: String
  }

  connect() {
    const initialValue = this.initialValue || (this.expressionTarget.value ? this.expressionTarget.value : "")
    this.expressionTarget.value = initialValue
    this.error = ""
    this.evaluate() // Initial evaluation
  }

  evaluate(event) {
    if (event && event.type === "keydown" && event.key === "Enter") {
      event.preventDefault()
    }

    const expression = this.expressionTarget.value.trim()

    // If empty, clear errors and results
    if (expression === "") {
      this.error = ""
      this.resultTarget.textContent = ""
      return
    }

    // Check for letters first
    if (/[a-zA-Z]/.test(expression)) {
      this.error = "Letters are not allowed. Please only use numbers and math operators."
      return
    }

    // Check for special characters
    // This regex allows only numbers, basic math operators, decimal points, parentheses, and spaces
    if (/[^0-9+\-*/.()\s]/.test(expression)) {
      this.error = "Special characters are not allowed. Please only use numbers and basic math operators (+, -, *, /)."
      return
    }

    // Prevent evaluation if last character is an operator (incomplete expression)
    if (/[+\-*/]$/.test(expression)) {
      this.error = ""
      this.resultTarget.textContent = ""
      return
    }

    // Check for division by zero
    if (expression.includes('/')) {
      const parts = expression.split('/')
      if (parts.length > 1) {
        try {
          const divisor = eval(parts[1].trim())
          if (divisor === 0) {
            this.error = "Dividing by zero is not allowed"
            return
          }
        } catch (e) {
          // Continue to evaluation if divisor is not valid
        }
      }
    }

    try {
      const result = eval(expression)

      if (isNaN(result)) {
        this.error = "Invalid expression"
        return
      }

      if (result > this.maxValue) {
        this.error = `Weight cannot exceed ${this.maxValue} ${this.unitValue}`
        return
      }

      // Show result in help-block immediately
      this.error = ""
      this.resultTarget.textContent = `${result} ${this.unitValue}`

      // Only update input field on blur or button click
      if (event && (event.type === "blur" || event.type === "click")) {
        this.expressionTarget.value = result
        this.resultTarget.textContent = ''
      }
    } catch (e) {
      this.error = "Invalid expression"
    }
  }

  // Getter/setter for error messages
  get error() {
    return this._error
  }

  set error(message) {
    this._error = message
    if (message) {
      this.resultTarget.textContent = message
      this.resultTarget.classList.add("weight-input__result_error")
    } else {
      this.resultTarget.classList.remove("weight-input__result_error")
    }
  }
}
